'use es6';

import { ACTIVELY_PUBLISHING, FAILED_TO_PUBLISH } from 'conversations-message-history/unpublished-messages/constants/messageTypes';
import { getMessage } from 'conversations-message-history/unpublished-messages/operators/getters';
import { isVisitorTypingMessage } from '../../typing-indicators/operators/isVisitorTypingMessage';
import { getType, getSenderType } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { VISITOR } from 'conversations-message-history/common-message-format/constants/legacySenderTypes';
import { supportedMessageTypes } from '../constants/supportedMessageTypes';
export const isSupportedMessageType = message => {
  let type = getType(message);
  if (type === ACTIVELY_PUBLISHING || type === FAILED_TO_PUBLISH) {
    message = getMessage(message);
    if (getSenderType(message) !== VISITOR) {
      return false;
    }
    type = getType(message);
  }
  if (isVisitorTypingMessage(message)) {
    return false;
  }
  return Object.keys(supportedMessageTypes).some(messageType => messageType === type);
};